// Delegated GA4 CTA tracking: any anchor/button with data-ga-cta fires a
// cta_click carrying its canonical label, placement area, and destination.
// Forms with data-ga-cta fire on submit instead, so Enter counts like the
// button. gtag's default beacon transport survives the navigation.
(function (window, document) {
    function send(el) {
        if (typeof window.gtag !== 'function') return;
        window.gtag('event', 'cta_click', {
            cta_label: el.getAttribute('data-ga-cta'),
            cta_area: el.getAttribute('data-ga-area') || 'page',
            link_url: el.getAttribute('href') || el.getAttribute('action') || ''
        });
    }
    document.addEventListener('click', function (e) {
        var el = e.target.closest && e.target.closest('a[data-ga-cta], button[data-ga-cta]');
        if (el) send(el);
    }, true);
    document.addEventListener('submit', function (e) {
        if (e.target.matches && e.target.matches('form[data-ga-cta]')) send(e.target);
    }, true);
})(window, document);
